import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './huggg.module.scss';
import { Button as TitleTypography } from '@huggg/react-components';
import HugggImage from './HugggImage';

const renderTextFields = (title, description) => (
  <>
    {title && (
      <TitleTypography className={classnames(styles.title)}>
        {title}
      </TitleTypography>
    )}
    {description && (
      <div className={classnames(styles.description)}>{description}</div>
    )}
  </>
);

const Huggg = props => {
  const { huggg, hideImage, hideDescription, imageOverride, titleOverride, descriptionOverride } = props;

  const title = titleOverride || huggg?.purchase?.label;
  const description = !hideDescription ? descriptionOverride || huggg?.meta?.customDescription || huggg?.purchase?.merchandising_title : null;

  return (
    <div className={styles.huggg}>
      {!hideImage && <HugggImage huggg={huggg} imageOverride={imageOverride} />}
      {renderTextFields(title, description)}
    </div>
  );
};

Huggg.propTypes = {
  huggg: PropTypes.object.isRequired,
  hideImage: PropTypes.bool,
  imageOverride: PropTypes.string,
  titleOverride: PropTypes.string,
  descriptionOverride: PropTypes.string,
  hideDescription: PropTypes.bool,
};

export default Huggg;
